import template from './plan.html';
import controller from './plan.controller';
import './plan.scss';

const planComponent = {
  bindings: {},
  template,
  controller,
};

export default planComponent;



// WEBPACK FOOTER //
// ./client/app/components/plan/plan.component.js